import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// ── PWA: Service Worker registration ────────────────────────
// Mantém o app instalável em Android e iOS, com cache offline-first do shell.
// API calls (/api/*) e domínios remotos NÃO são cacheados — sempre rede.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        // Atualização: quando houver novo SW disponível, pedir reload silencioso
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              // versão nova disponível — pedir para ativar
              reg.waiting?.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => {
        // Falha silenciosa — app funciona normalmente sem SW
      });
  });
}
